import { gql } from "@apollo/client"

export const ASSOCIATE_APPLICATION_ELIGIBILITY_QUERY = gql`
  query AssociateApplicationEligibility {
    associateApplicationEligibility {
      eligible
      pathEligible
      blockingReasons
      backgroundCheck {
        complete
      }
      playingAbilityTest {
        complete
        expired
      }
      qualifyingLevel {
        complete
        expired
      }
      dues {
        complete
        balanceCents
      }
      age {
        complete
        dateOfBirth
      }
    }
  }
`
